export default {
  "site_name": "CSSBuy.watch",
  "site_tagline": "CSSBuy Spreadsheet Atualizado 2026",
  "nav_home": "Início",
  "nav_categories": "Categorias",
  "nav_blog": "Blog",
  "nav_about": "Sobre",
  "dropdown_placeholder": "Categorias",
  "footer_navigation": "Navegação",
  "footer_social": "Redes Sociais",
  "footer_newsletter": "Receba Atualizações",
  "footer_newsletter_placeholder": "Seu melhor email",
  "footer_newsletter_button": "Inscrever",
  "footer_rights": "Todos os direitos reservados.",
  "footer_disclaimer": "Aviso: Não vendemos produtos. Este site é um guia educacional com links de terceiros.",
  "all_rights": "Todos os direitos reservados."
};